module.exports = "/assets/data/54bdc89e7585faf805ba264e77d7d882-GL51.data.json";